import React from 'react';

import { ClientProvider } from '@bessemercws/providers';
import { createRoot } from 'react-dom/client'; 

import App from './App';

const domNode = document.getElementById('root');
if (!domNode) throw new Error('Cannot find root');
const root = createRoot(domNode);

/**
 * Root Application For Bessemer Client Website
 *
 * @example
 * <ClientProvider>     -- Provider for managing application state
 *   <App />            -- Client Application, contains: data provider, timeout, theme and routes
 * </ClientProvider>,
 */
root.render(
  <ClientProvider>
    <App />
  </ClientProvider>
);
